module.exports = __webpack_public_path__ + "img/dashboard.3552de89.svg";